import { useParams, useLocation } from 'react-router-dom'
import { LayerMetadataForm } from './LayerMetadataForm'
import { useHazardLayerMetadata } from '@app/modules/Home/Data/hooks/useHazardLayerMetadata'
import { HazardSourceLink } from '@app/types/layerTypes'

export const LayerMetadataManagement = () => {
  const { layerId } = useParams<{ layerId: string }>()
  const { state } = useLocation()
  const hazardMeta = useHazardLayerMetadata(layerId)

  const mergedSources: HazardSourceLink[] =
    state?.allSources ?? hazardMeta?.metadata?.source_links ?? []

  return (
    <LayerMetadataForm
      key={hazardMeta?.id ?? layerId}
      layerId={hazardMeta?.id ?? layerId ?? ''}
      defaultValues={{
        ...hazardMeta?.metadata,
        source_links: mergedSources,
      }}
    />
  )
}
